module.exports = __webpack_public_path__ + "img/chat_q.9ea2d463.svg";